<template>
    <div :class="['form-group', `col-md-${col}`, {'has-error':isError}]">
        <slot></slot>
        <span v-if="isError" class="help-block error-help-block text-danger" style="font-size: 0.9em">{{$parent.formErrors[field][0]}}</span>
    </div>
</template>

<script>
export default {
    name: "FormGroup",
    props: {
        col: {
            default: '2'
        },
        field: {
            default: 'error'
        }
    },
    data (){
      return {
        isError: false
      }
    },
    watch: {
        '$parent.formErrors': {
            handler(val) {
                this.isError = Object.entries(val).length > 0 && val.hasOwnProperty(this.field);
            },
            deep: true
        }
    }
}
</script>

<style scoped>

</style>
